import React, { useEffect, useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { isArray, isEmpty } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';
import useWindowSize from '../../../hooks/useWindowSize';

import queryString from 'query-string';

import { array } from 'prop-types';

import {Grid, GridNoRecords, GridColumn as Column, GridToolbar} from '@progress/kendo-react-grid';
import { process as kendoProcess, filterBy } from '@progress/kendo-data-query';
import {Operators, TextFilter, NumericFilter, DateFilter, BooleanFilter} from '@progress/kendo-react-data-tools';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobModal from '../../../components/BobModal';
import CreateEquipmentOrSystemModal from '../EquipmentPage/CreateEquipmentOrSystemModal';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import DeleteEquipmentModal from '../EquipmentPage/DeleteEquipmentModal';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import { dashboardContent } from '../../../localization/en-us/dashboardContent';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';
import FilterPanel from '../../../components/K2AFilterControl/FilterPanel';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './Table.module.css';

const initialDataStateFilter = {
    logic:   'and',
    filters: []
};

const initialDataState = {
    sort:   [],
    filter: initialDataStateFilter,
    take:   10,
    skip:   0
};

const EquipmentTable = ({
    activeNavCompany,
    activeNavClient,
    activeNavSite,
    bobLoading,
    companies,
    createEquipmentModalOpen,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    deleteEquipmentModalOpen,
    exportSiteEquipment,
    fetchDashboardEquipmentData,
    fetchKpiData,
    fetchNavClients,
    fetchSingleEquipment,
    history,
    equipment,
    equipmentFilters,
    handleToggleCreateEquipmentModal,
    handleToggleDeleteEquipmentModal,
    handleToggleSubscribeToEquipmentAlertsModal,
    resetNavOptions,
    refreshTab,
    setExportSiteEquipment,
    setRefreshTab,
    setNavCompany,
    setTableProps,
    searchTerm,
    siteEquipment,
    siteEquipmentMeta,
    subscribeToAlertsEqquipmentModalOpen,
    targetNavCompany,
    totalsData,
    workbookModeEnabled,
    ...props
}) => {
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [equipmentData, setEquipmentData] = useState(null);
    const [equipmentColumnWidth, setEquipmentColumnWidth] = useState(250);
    const [gridDataState, setGridDataState] = useState(initialDataState);
    const [gridFilterText, setGridFilterText] = useState('');

    const queryValues = queryString.parse(history.location.search);
    const companyId = queryValues.company;
    const clientId = queryValues.client;
    const siteId = queryValues.site;

    const isInitialMount = useRef(true);
    const _export = useRef(null);
    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const children = gridRef.current.props.children;
        children.forEach(child => {
            if (isArray(child)) {
                const columns = child;
                setEquipmentColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'equipmentName', 250, true));
            }
        });
    }, [windowSize]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setGridDataState({...gridDataState, filter: initialDataStateFilter});
            setGridFilterText('');
        }
    }, [workbookModeEnabled]);

    useEffect(() => {
        setTake(10);
    }, [siteId]);

    useEffect(() => {
        if (activeNavSite && activeNavSite.name && isEmpty(siteEquipment)) {
            initializeFetch();
        }
    }, [activeNavSite]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (equipmentFilters.type || Object.values(equipmentFilters.priority).includes(true)) {
                if (!isEmpty(targetNavCompany) && !isEmpty(siteEquipmentMeta)) {
                    initializeFetch();
                }
            } else {
                const init = async () => {
                    initializeFetch();
                };

                if (activeNavCompany.id && !isEmpty(siteEquipment)) init();
            }
        }
    }, [equipmentFilters, dashboardStartTimeStamp, dashboardEndTimeStamp, searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            let promises = [];

            promises.push(fetchKpiData(activeNavCompany.id, 'SiteEquipment', activeNavSite.id, dashboardStartTimeStamp, dashboardEndTimeStamp));
            promises.push(fetchDashboardEquipmentData(activeNavCompany.id, 'SiteEquipment', { clientId: activeNavClient.id, siteId: activeNavSite.id, sort: 'default^desc', searchFilter: searchTerm, page: 1, limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }));

            await Promise.all(promises.map(p => p.catch(err => err)));
            setRefreshTab();
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    useEffect(() => {
        if (exportSiteEquipment) {
            exportExcel();
        }
    }, [exportSiteEquipment]);

    const initializeFetch = async () => {
        let promises = [];

        promises.push(fetchKpiData(activeNavCompany.id, 'SiteEquipment', activeNavSite.id, dashboardStartTimeStamp, dashboardEndTimeStamp));
        promises.push(fetchDashboardEquipmentData(activeNavCompany.id, 'SiteEquipment', { clientId: activeNavClient.id, siteId: activeNavSite.id, sort: 'default^desc', limit: take, searchFilter: searchTerm, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp }));

        await Promise.all(promises.map(p => p.catch(err => err)));
    };

    const fetchEquipmentListAfterCreate = async searchTerm => {
        await fetchDashboardEquipmentData(activeNavCompany.id, 'SiteEquipment', { clientId: activeNavClient.id, siteId: activeNavSite.id, sort: 'default^desc', searchFilter: '', limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp });
    };

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `equipment?client=${dataItem.clientId}&company=${queryValues.company}&equipment=${dataItem.equipmentId}&site=${dataItem.siteId}`;
    };

    const renderScoreNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `equipment?client=${dataItem.clientId}&company=${queryValues.company}&equipment=${dataItem.equipmentId}&site=${dataItem.siteId}&viewChildId=4b25aeb8-45d4-4522-9f77-870ab40abb07`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/equipment';

        const queryValues = queryString.parse(history.location.search);
        queryValues.client = dataItem.clientId;
        queryValues.site = dataItem.siteId;
        queryValues.equipment = dataItem.equipmentId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);

        const options = {extendedData: true};
        await fetchSingleEquipment(queryValues, options);
    };

    const nameCell = props => {
        return (
            <td>
                <Link
                    to={renderNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }
        return (
            <td>
                <img className={ props.dataItem[props.field] > 0 ? classes.IconImage: classes.IconImageGray} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const scoresCell = props => {
        let value = props.dataItem[props.field];
        value = value.toString().includes('.') ? parseFloat(value).toFixed(2) : value;

        return (
            <td>
                <Link
                    to={renderScoreNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {value + '%'}
                </Link>
            </td>
        );
    };

    const fetchEquipmentDataForDelete = (equipmentData) => {
        setEquipmentData(equipmentData);
        handleToggleDeleteEquipmentModal(true);
    };

    const subscribeEquipmentData = (equipmentData) => {
        equipmentData.name = equipmentData.equipmentName;
        equipmentData.id = equipmentData.equipmentId;

        setEquipmentData(equipmentData);
        handleToggleSubscribeToEquipmentAlertsModal(true);
    };

    const areaCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <HtmlTooltip
                    information={props.dataItem[props.field]}
                    placement={'top'}
                    body={
                        <div id={props.dataItem['equipmentId']} className={classes.AreaText}>
                            {props.dataItem[props.field]}
                        </div>
                    }
                    disableHoverStatus={props.dataItem['areas'] && props.dataItem['areas'].length <= 1 ? true : false}
                />
            </td>
        );
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    entityData={props.dataItem}
                    onSubscribeAlerts={(entityData) => { subscribeEquipmentData(entityData); }}
                    onDelete={(entityData) => fetchEquipmentDataForDelete(entityData)}
                    onFetch={(entityData) => handleEditEquipment(entityData)}
                />
            </td>
        );
    };

    const handleEditEquipment = equipmentData => {
        setEquipmentData(equipmentData);
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=7035ee2f-b8ee-48ee-a9ac-ac522917dcdd&client=${activeNavClient.id}&company=${activeNavCompany.id}&entityId=${equipmentData.equipmentId}&entityType=equipment&parentId=33ba6af0-1e7a-4fcf-b75b-f355a01a962b&site=${activeNavSite.id}`,
                state:    { 'returnUrl': `/v2/dashboard/site?appId=${bob.key}&childId=bb5be75b-d466-48d5-99da-79cd66504f20&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=c0c505f5-c7fc-4317-8cb6-f6e631142a77&site=${activeNavSite.id}`}
            })
            :
            handleToggleCreateEquipmentModal(true);
    };

    const fetchEquipments = async searchTerm => {
        await fetchDashboardEquipmentData(companyId, 'SiteEquipment', { clientId, siteId, sort: 'default^desc', searchFilter: '', limit: take, startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp });
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setGridDataState(e.dataState);
    };

    const getDisplayCell = fieldName => {
        switch (fieldName) {
            case 'equipmentName':
                return nameCell;
            case 'areaList':
                return areaCell;
            case 'equipmentScore':
                return scoresCell;
            case 'highFaultCount':
            case 'mediumFaultCount':
            case 'lowFaultCount':
                return priorityCell;
            case '':
                return actionsCell;
            default:
                return null;
        }
    };

    const [columnNames] = useState([
        {
            field:  'equipmentName',
            title:  dashboardContent.equipment,
            id:     'equipmentColumn',
            filter: 'text',
            width:  '200px'
        },
        {
            field:  'equipmentTypeName',
            title:  dashboardContent.equipmentType,
            width:  '275px',
            filter: 'text'
        },
        {
            field:  'areaList',
            title:  dashboardContent.area,
            width:  '150px',
            filter: 'text'
        },
        {
            field:  'sensorCount',
            title:  dashboardContent.sensors,
            width:  '175px',
            filter: 'numeric'
        },
        {
            field:  'equipmentScore',
            title:  dashboardContent.score,
            width:  '175px',
            filter: 'numeric'
        },
        {
            field:  'totalFaultCount',
            title:  dashboardContent.faults,
            width:  '175px',
            filter: 'numeric'
        },
        {
            field:  'highFaultCount',
            title:  dashboardContent.high,
            width:  '175px',
            filter: 'numeric'
        },
        {
            field:  'mediumFaultCount',
            title:  dashboardContent.medium,
            width:  '175px',
            filter: 'numeric'
        },
        {
            field:  'lowFaultCount',
            title:  dashboardContent.low,
            width:  '175px',
            filter: 'numeric'
        },
        {
            field:      '',
            title:      '',
            width:      '75px',
            locked:     true,
            sortable:   false,
            filterable: false,
            actionCell: true
        }
    ]);

    const gridFields = columnNames.filter(c => !c.actionCell).map(column => {
        const filterType = column.filter === 'text' ? TextFilter : column.filter === 'numeric' ? NumericFilter : column.filter === 'date' ? DateFilter : BooleanFilter;
        const operatorList = column.filter === 'text' ? Operators.text : column.filter === 'numeric' ? Operators.numeric : column.filter === 'date' ? Operators.date : Operators.boolean;
        return {
            name:      column.field,
            label:     column.title,
            filter:    filterType,
            operators: operatorList
        };
    });

    const getExportFileName = () => {
        let fileName = 'Site Equipment.xlsx';
        if (activeNavSite.name) {
            fileName = `${ activeNavSite.name } - Site Equipment.xlsx`;
        }
        return fileName;
    };

    const exportExcel = () => {
        const data = filterBy(siteEquipment, gridDataState.filter);
        const columns = gridRef.current.columns;
        columns.find(c => c.field === 'equipmentName').width = 250;
        if (_export.current !== null) {
            _export.current.save(data, columns);
        }
        setExportSiteEquipment(false);
    };

    const clearGridFilter = filter => {
        setGridDataState({...gridDataState, filter: filter ? filter : initialDataStateFilter});
    };

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
                {
                    `.k-toolbar {
                            order: 1;
                            border-top: inset 1px rgba(0, 0, 0, 0.12);
                            max-height: 5.8rem;
                    }`
                }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <ExcelExport
                    data={kendoProcess(siteEquipment, gridDataState).data}
                    ref={_export}
                    fitlerable
                    fileName={getExportFileName()}
                />
                <Grid
                    ref={gridRef}
                    sortable
                    filterable={workbookModeEnabled}
                    className={classes.KendoGrid}
                    data={kendoProcess(siteEquipment, gridDataState)}
                    {...gridDataState}
                    onDataStateChange={onDataStateChange}
                    pageable={pageable}
                    reorderable
                >
                    {
                        workbookModeEnabled ?
                            <GridToolbar>
                                <FilterPanel
                                    title={'Site Equipment Filter Builder'}
                                    filter={gridDataState.filter}
                                    filterText={gridFilterText}
                                    fields={gridFields}
                                    columns={gridRef.current ? gridRef.current.columns : []}
                                    setFilter={clearGridFilter}
                                    setFilterText={setGridFilterText}
                                />
                            </GridToolbar>
                            : null
                    }
                    {
                        bobLoading.includes('SiteEquipment') || isEmpty(siteEquipmentMeta) ?
                            <GridNoRecords>
                                Loading equipment
                            </GridNoRecords>
                            :
                            null
                    }
                    {
                        columnNames.map((column, index) => (
                            <Column
                                key={index}
                                field={column.field}
                                title={column.title}
                                width={column.field !== 'equipmentName' ? column.width : equipmentColumnWidth}
                                filter={column.filter ? column.filter : null}
                                cell={getDisplayCell(column.field)}
                                id={column.id}
                                locked={column.locked ? true : false}
                                sortable={column.sortable === false ? false : true}
                                filterable={column.filterable === false ? false : true }
                            />
                        ))
                    }
                </Grid>

                {
                    subscribeToAlertsEqquipmentModalOpen ?
                        <CreateSubscriptionModal
                            parent={equipmentData}
                            parentLabel="Equipment"
                            handleToggleSubscribeToAlertsModal={handleToggleSubscribeToEquipmentAlertsModal}
                        />
                        :
                        null
                }
                {
                    createEquipmentModalOpen ?
                        <BobModal
                            title={ equipmentData ? 'Edit Equipment' : 'Add New Equipment'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                setEquipmentData(null);
                                handleToggleCreateEquipmentModal(false);}}
                        >
                            <CreateEquipmentOrSystemModal
                                equipment={equipmentData}
                                isEdit={equipmentData ? true : false}
                                fetchEquipmentListAfterCreate={(name) => fetchEquipmentListAfterCreate(name)}
                                onClose={() => {
                                    setEquipmentData(null);
                                    handleToggleCreateEquipmentModal(false);}}
                            />
                        </BobModal> : ''
                }
                {
                    deleteEquipmentModalOpen ?
                        <BobModal
                            title={'Delete Entity'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                handleToggleDeleteEquipmentModal(false);
                                setEquipmentData(null);}}
                        >
                            <DeleteEquipmentModal
                                equipment={equipmentData}
                                fetchEquipments={fetchEquipments}
                                onClose={() => {
                                    handleToggleDeleteEquipmentModal(false);
                                    setEquipmentData(null);}}
                            />
                        </BobModal> : ''
                }
                {
                    bobLoading.includes('SiteEquipment') || isEmpty(siteEquipmentMeta) ?
                        <BobLoadingMask
                            className={classes.Loader}
                        />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

EquipmentTable.defaultProps = {
    siteEquipment: []
};

EquipmentTable.propTypes = {
    siteEquipment: array
};

const mapStateToProps = state => ({
    activeNavClient:         state.bob.activeNavClient,
    activeNavCompany:        state.bob.activeNavCompany,
    activeNavSite:           state.bob.activeNavSite,
    bobLoading:              state.bob.bobLoading,
    companies:               state.core.companies,
    dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
    dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
    equipmentFilters:        state.dashboard.equipmentFilters,
    siteEquipment:           state.dashboard.siteEquipment,
    siteEquipmentMeta:       state.dashboard.siteEquipmentMeta,
    targetNavCompany:        state.bob.targetNavCompany
});

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EquipmentTable));
